"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var typestyle_1 = require("typestyle");
var activities_1 = require("../../helpers/activities");
var layouts_1 = require("../../styles/layouts");
var card_1 = require("./card");
var styles_1 = require("./styles");
exports.FeaturedScenes = function (props) {
    var scenes = props.scenes, title = props.title;
    // the featured scenes grid is designed to display a grid of scenes in
    // 3 columns (apart from mobile), so if we find for some reason we have
    // been provided more that we want (there's some exciting edge cases
    // apparently), we throw away the exceess
    var trimAmount = scenes.length % 3;
    var scenesToDisplay = trimAmount > 0 ? scenes.slice(0, -trimAmount) : scenes;
    if (scenesToDisplay.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: typestyle_1.classes(layouts_1.boxLayout, styles_1.styles.featuredScenes) },
        React.createElement("h3", null, title),
        React.createElement("div", { className: styles_1.styles.featuredGrid }, scenesToDisplay.map(function (scene, index) { return (React.createElement(card_1.SceneCard, { key: scene.accountId + ":" + scene.sceneId, scene: scene, thumbnail: scene.thumbnail || activities_1.getThumbnailForScene(scene.activityType, index) })); }))));
};
